import useJalali from '@/components/DatePicker/useJalali';

const JalaliListener = () => {
  useJalali();
  return <></>;
};

export default JalaliListener;
